<template>
  <div
    class="icon-selector-persons-count"
    :class="`theme-${props.theme}`"
    data-private-info="true"
  >
    <SvgIcon
      v-for="(step, index) in props.steps"
      :name="`user${index + 1}`"
      :class="{
        active:
          modelValue > midInterval(props.steps[index - 1], step) &&
          modelValue <= midInterval(step, props.steps[index + 1]),
      }"
      @click="updateValue(step)"
    />
  </div>
</template>

<script setup lang="ts">
import './IconSelectorPersonsCount.scss';
import SvgIcon from 'ewi-ui/components/1-atoms/Icon/SvgIcon/SvgIcon.vue';

interface Props {
  modelValue: number;
  steps: number[];
  theme?: string;
}

const props = withDefaults(defineProps<Props>(), {
  theme: '',
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void;
}>();

const updateValue = (val: number) => {
  emit('update:modelValue', val);
};

const midInterval = (minValue?: number, maxValue?: number): number => {
  if (typeof minValue === 'undefined') {
    return 0;
  }
  if (typeof maxValue === 'undefined') {
    return minValue;
  }
  return (maxValue - minValue) / 2 + minValue;
};
</script>
